//@flow
import NotificationBadge from "./NotificationBadge";
export { NotificationBadge };